<template>
  <div class="absolute left-0 !top-97px !h-[calc(100%-97px)] w-420px z-99 p-10px">
  <div data-v-14b8093e="" class="absolute top-0px left-0px h-full w-300px left-bg-modal"></div>
  <div class="w-full h-full rounded-10px p-10px bg-[#051A22CC] ">
     <security-card class="h-9/25"></security-card>
     <personnel-area-card class="h-8/25"></personnel-area-card>
     <partici-pating-personnel-card class="h-8/25"></partici-pating-personnel-card>
  </div>
  </div>
</template>

<script>
import SecurityCard from './securityCard.vue'
import PersonnelAreaCard from './personnelAreaCard.vue'
import ParticiPatingPersonnelCard from './particiPatingPersonnelCard.vue'

export default {
  name: 'LeftCom',
  props: [],
  components: { SecurityCard, PersonnelAreaCard, ParticiPatingPersonnelCard },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.left-bg-modal {
    z-index: -1;
    background: linear-gradient(90.39deg, rgba(4, 17, 24, .9) 12.55%, rgba(4, 16, 23, .63) 55.92%, rgba(4, 18, 26, 0) 99.62%);
}
</style>
